module.exports = __webpack_public_path__ + "img/superstore_img.06013d37.png";